// 認證狀態檢查
import { getCookie, buildApiUrl } from '@redpanda/utils';
import { checkUrlToken } from './checkUrlToken';
/**
 * 檢查當前認證狀態
 * @param identityServiceUrl Identity Service 的 URL
 * @param productionDomain 生產環境的域名
 * @param systemName 系統名稱 (用於權限檢查，可選)
 * @returns 認證結果
 */
export async function checkAuthStatus(identityServiceUrl, productionDomain, systemName) {
    var _a, _b;
    try {
        // 1. 首先檢查 URL token（解決 Safari 第三方 Cookie 問題）
        const urlAuthResult = await checkUrlToken(identityServiceUrl, productionDomain);
        if (urlAuthResult.authenticated) {
            // 如果需要檢查系統權限
            if (systemName) {
                const hasAccess = checkSystemAccess(systemName, urlAuthResult.user);
                return Object.assign(Object.assign({}, urlAuthResult), { hasAccess, noAccess: !hasAccess });
            }
            return urlAuthResult;
        }
        // 2. 檢查現有 Cookie - 使用 token 驗證而非跨域 Cookie
        const existingToken = getCookie('auth_token');
        if (!existingToken) {
            return { authenticated: false };
        }
        const apiUrl = buildApiUrl(identityServiceUrl, '/auth/token/verify');
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: existingToken }),
        });
        const data = await response.json();
        if (data.valid && data.user) {
            const result = {
                authenticated: true,
                user: data.user
            };
            // 如果需要檢查系統權限
            if (systemName) {
                const hasAccess = checkSystemAccess(systemName, data.user);
                result.hasAccess = hasAccess;
                result.noAccess = !hasAccess;
            }
            return result;
        }
        return { authenticated: false };
    }
    catch (error) {
        // 檢查多種網路連線錯誤類型
        const isNetworkError = (error.name === 'TypeError' && ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('Failed to fetch'))) ||
            ((_b = error.message) === null || _b === void 0 ? void 0 : _b.includes('NetworkError')) ||
            error.code === 'ERR_NETWORK' ||
            error.code === 'ECONNREFUSED';
        if (isNetworkError) {
            console.log('Identity service connection failed, redirecting to login');
            window.location.href = '/login';
            return {
                authenticated: false,
                error: 'Network error',
                networkError: isNetworkError
            };
        }
        return {
            authenticated: false,
            error: 'Network error',
            networkError: isNetworkError
        };
    }
}
/**
 * 檢查用戶是否有權訪問指定系統
 * @param systemName 系統名稱
 * @param user 用戶資料
 * @returns 是否有權限
 */
function checkSystemAccess(systemName, user) {
    if (!user || !user.allowedSystems)
        return false;
    // 如果用戶有 ALL 權限，可以訪問所有系統
    if (user.allowedSystems.includes('ALL'))
        return true;
    // 檢查是否有指定系統的權限
    return user.allowedSystems.includes(systemName);
}
